export var createErrorMonitorProp = function (errorMonitor) { return ({
    captureException: function (exception, options) {
        return errorMonitor.captureException(exception, options);
    },
    captureMessage: function (message, options) {
        return errorMonitor.captureMessage(message, options);
    },
    addBreadcrumb: function (breadcrumb) {
        errorMonitor.addBreadcrumb(breadcrumb);
    },
}); };
//# sourceMappingURL=errorMonitorProp.js.map